import classNames from "../classNames";

function HoverCard({ children, className }) {
  return (
    <div
      className={classNames(className, "rounded-2 p-3 cursor-pointer")}
      style={{
        border: "1px solid #e9ecef",
        transition: "all 0.3s ease",
        minHeight: "140px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.12)";
      }}
    >
      {children}
    </div>
  );
}

export default HoverCard;
